export const EDIT_VIEW_DETAILS = 'EDIT_VIEW_DETAILS';
export const SHOW_VIEW_DETAILS = 'SHOW_VIEW_DETAILS';
export const VIEW_DETAILS_SUCCESS = 'VIEW_DETAILS_SUCCESS';
export const VIEW_DETAILS_ERROR = 'VIEW_DETAILS_ERROR';